import React from 'react';
import PositionsInRange from '../../components/analytics/PositionsInRange';

/**
 * Download section — focused home for data exports. Today: closed positions
 * for the FilterBar range with CSV download. Future hooks: FY-bounded P&L
 * statements, tax-grouped reports, signed-URL exports of large result sets.
 *
 * Kept separate from the Trades section so the export surface has its own
 * IA slot (Trades is now purely analytical: top trades, distribution,
 * streaks, rolling win rate).
 */
const DownloadSection: React.FC = () => {
  return (
    <PositionsInRange />
  );
};

export default DownloadSection;
